// components/audioFiles.js

import Tutorial1_1 from "../audio/Tutorial1_Teil1.mp3"
import Tutorial1_2 from "../audio/Tutorial1_Teil2.mp3";
import Tutorial1_3 from "../audio/Tutorial1_Teil3.mp3";
import Tutorial1_4 from "../audio/Tutorial1_Teil4.mp3";
import Tutorial1_5 from "../audio/Tutorial1_Teil5.mp3";
import Tutorial1_6 from "../audio/Tutorial1_Teil6.mp3";
import Tutorial1_7 from "../audio/Tutorial1_Teil7.mp3";
import Tutorial1_8 from "../audio/Tutorial1_Teil8.mp3";
import Tutorial1_9 from "../audio/Tutorial1_Teil9.mp3";
import Tutorial1_10 from "../audio/Tutorial1_Teil10.mp3";
import Tutorial1_11 from "../audio/Tutorial1_Teil11.mp3";
import Tutorial1_12 from "../audio/Tutorial1_Teil12.mp3";
import Tutorial1_13 from "../audio/Tutorial1_Teil13.mp3";
import Tutorial1_14 from "../audio/Tutorial1_Teil14.mp3";
import Tutorial1_15 from "../audio/Tutorial1_Teil15.mp3";
import ButtonSound1 from '../audio/Button_Sound1.mp3';
import ButtonSound2 from '../audio/Button_Sound1.mp3';
import Saving from '../audio/Saving.mp3';
import MagicLoad from '../audio/MagicLoad.mp3';
import Lob1 from '../audio/Lob1.mp3';
import Lob2 from '../audio/Lob2.mp3';
import Lob3 from '../audio/Lob3.mp3';
import Lob4 from '../audio/Lob4.mp3';
import Lob5 from '../audio/Lob5.mp3';
import Lob6 from '../audio/Lob6.mp3';
import Lob7 from '../audio/Lob7.mp3';
import Lob8 from '../audio/Lob8.mp3';
import Lob9 from '../audio/Lob9.mp3';
import Lob10 from '../audio/Lob10.mp3';
import Adler from '../audio/Itemsounds/Adler.mp3';
import Auge from '../audio/Itemsounds/Auge.mp3';
import Bett from '../audio/Itemsounds/Bett.mp3';
import Biene from '../audio/Itemsounds/Biene.mp3';
import Brille from '../audio/Itemsounds/Brille.mp3';
import Decke from '../audio/Itemsounds/Decke.mp3';
import Dose from '../audio/Itemsounds/Dose.mp3';
import drehen from '../audio/Itemsounds/drehen.mp3';
import Eltern from '../audio/Itemsounds/Eltern.mp3';
import Eule from '../audio/Itemsounds/Eule.mp3';
import fehlt from '../audio/Itemsounds/fehlt.mp3';
import Flosse from '../audio/Itemsounds/Flosse.mp3';
import Gabel from '../audio/Itemsounds/Gabel.mp3';
import Gardine from '../audio/Itemsounds/Gardine.mp3';
import gehen from '../audio/Itemsounds/gehen.mp3';
import geht from '../audio/Itemsounds/geht.mp3';
import Grab from '../audio/Itemsounds/Grab.mp3';
import grußen from '../audio/Itemsounds/grußen.mp3';
import Hande from '../audio/Itemsounds/Hande.mp3';
import Hase from '../audio/Itemsounds/Hase.mp3';
import Hauser from '../audio/Itemsounds/Hauser.mp3';
import Hitze from '../audio/Itemsounds/Hitze.mp3';
import Hohe from '../audio/Itemsounds/Hohe.mp3';
import Hund from '../audio/Itemsounds/Hund.mp3';
import Jacke from '../audio/Itemsounds/Jacke.mp3';
import Kalb from '../audio/Itemsounds/Kalb.mp3';
import Kalte from '../audio/Itemsounds/Kalte.mp3';
import Katze from '../audio/Itemsounds/Katze.mp3';
import Kette from '../audio/Itemsounds/Kette.mp3';
import Klavier from '../audio/Itemsounds/Klavier.mp3';
import Kuche from '../audio/Itemsounds/Kuche.mp3';
import Kuh from '../audio/Itemsounds/Kuh.mp3';
import Land from '../audio/Itemsounds/Land.mp3';
import Lawine from '../audio/Itemsounds/Lawine.mp3';
import Liebe from '../audio/Itemsounds/Liebe.mp3';
import Lupe from '../audio/Itemsounds/Lupe.mp3';
import Maler from '../audio/Itemsounds/Maler.mp3';
import Mause from '../audio/Itemsounds/Mause.mp3';
import melden from '../audio/Itemsounds/melden.mp3';
import Mohre from '../audio/Itemsounds/Mohre.mp3';
import Muhle from '../audio/Itemsounds/Muhle.mp3';
import Mutze from '../audio/Itemsounds/Mutze.mp3';
import Nase from '../audio/Itemsounds/Nase.mp3';
import Note from '../audio/Itemsounds/Note.mp3';
import Papier from '../audio/Itemsounds/Papier.mp3';
import Pfote from '../audio/Itemsounds/Pfote.mp3';
import Puppe from '../audio/Itemsounds/Puppe.mp3';
import Rose from '../audio/Itemsounds/Rose.mp3';
import Rabe from '../audio/Itemsounds/Rabe.mp3';
import Robbe from '../audio/Itemsounds/Robbe.mp3';
import Ruhe from '../audio/Itemsounds/Ruhe.mp3';
import Ruine from '../audio/Itemsounds/Ruine.mp3';
import Sahne from '../audio/Itemsounds/Sahne.mp3';
import Schule from '../audio/Itemsounds/Schule.mp3';
import Segel from '../audio/Itemsounds/Segel.mp3';
import sehen from '../audio/Itemsounds/sehen.mp3';
import Socke from '../audio/Itemsounds/Socke.mp3';
import Soße from '../audio/Itemsounds/Soße.mp3';
import Spalte from '../audio/Itemsounds/Spalte.mp3';
import Straße from '../audio/Itemsounds/Straße.mp3';
import Stufe from '../audio/Itemsounds/Stufe.mp3';
import Suche from '../audio/Itemsounds/Suche.mp3';
import Tanne from '../audio/Itemsounds/Tanne.mp3';
import traumen from '../audio/Itemsounds/traumen.mp3';
import Tube from '../audio/Itemsounds/Tube.mp3';
import Turnier from '../audio/Itemsounds/Turnier.mp3';
import verbinden from '../audio/Itemsounds/verbinden.mp3';
import Verbot from '../audio/Itemsounds/Verbot.mp3';
import verloben from '../audio/Itemsounds/verloben.mp3';
import Vorfahrt from '../audio/Itemsounds/Vorfahrt.mp3';
import vorlesen from '../audio/Itemsounds/vorlesen.mp3';
import vortreten from '../audio/Itemsounds/vortreten.mp3';
import wandern from '../audio/Itemsounds/wandern.mp3';
import Wasche from '../audio/Itemsounds/Wasche.mp3';
import Weg from '../audio/Itemsounds/Weg.mp3';
import winken from '../audio/Itemsounds/winken.mp3';
import Winter from '../audio/Itemsounds/Winter.mp3';
import Woche from '../audio/Itemsounds/Woche.mp3';
import Zahl from '../audio/Itemsounds/Zahl.mp3';
import Zehe from '../audio/Itemsounds/Zehe.mp3';
import Ziege from '../audio/Itemsounds/Ziege.mp3';
import Zug from '../audio/Itemsounds/Zug.mp3';
import Eisen from '../audio/Itemsounds/Eisen.mp3';
import vorsingen from '../audio/Itemsounds/vorsingen.mp3';
import Runde from '../audio/Itemsounds/Runde.mp3';
import Kiste from '../audio/Itemsounds/Kiste.mp3';
import Wolke from '../audio/Itemsounds/Wolke.mp3';
import Lampe from '../audio/Itemsounds/Lampe.mp3';
import Welpe from '../audio/Itemsounds/Welpe.mp3';
import Taste from '../audio/Itemsounds/Taste.mp3';
import Zange from '../audio/Itemsounds/Zange.mp3';
import Menge from '../audio/Itemsounds/Menge.mp3';
import rudern from '../audio/Itemsounds/rudern.mp3';
import Junge from '../audio/Itemsounds/Junge.mp3';
import Ende_Teil1 from "../audio/Ende_Teil1.mp3";
import Ende_Teil2 from "../audio/Ende_Teil2.mp3";
import Tontest from "../audio/Tontest.mp3";

export const audioFiles = {
    ButtonSound1,
    ButtonSound2,
    Saving,
    MagicLoad,
   Tutorial1_1,
   Tutorial1_2,
   Tutorial1_3,
   Tutorial1_4,
   Tutorial1_5,
   Tutorial1_6,
   Tutorial1_7,
   Tutorial1_8,
   Tutorial1_9,
   Tutorial1_10,
   Tutorial1_11,
   Tutorial1_12,
   Tutorial1_13,
   Tutorial1_14,
   Tutorial1_15,
   Lob1,
   Lob2,
   Lob3,
   Lob4,
   Lob5,
   Lob6,
   Lob7,
   Lob8,
   Lob9,
   Lob10,
   Ende_Teil1,
   Ende_Teil2,
   Adler,
   Auge,
   Bett,
   Biene,
   Brille,
   Decke,
   Dose,
   drehen,
   Eltern,
   Eule,
   fehlt,
   Flosse,
   Gabel,
   Gardine,
   geht,
   Grab,
   grußen,
   Hande,
   Hase,
   Hauser,
   Hitze,
   Hohe,
   Hund,
   Jacke,
   Kalb,
   Kalte,
   Katze,
   Kette,
   Klavier,
   Kuche,
   Kuh,
   Land,
   Lawine,
   Liebe,
   Lupe,
   Maler,
   Mause,
   melden,
   Mohre,
   Muhle,
   Mutze,
   Nase,
   Note,
   Papier,
   Pfote,
   Puppe,
   Rabe,
   Rose,
   Robbe,
   Ruhe,
   Ruine,
   Sahne,
   Schule,
   Segel,
   sehen,
   Socke,
   Soße,
   Spalte,
   Straße,
   Stufe,
   Suche,
   Tanne,
   traumen,
   Tube,
   Turnier,
   verbinden,
   Verbot,
   verloben,
   Vorfahrt,
   vorlesen,
   vortreten,
   wandern,
   Wasche,
   Weg,
   winken,
   Winter,
   Woche,
   Zahl,
   Zehe,
   Ziege,
   Zug,
   Eisen,
   vorsingen,
   Runde,
   Kiste,
   Wolke,
   Lampe,
   Welpe,
   Taste,
   Zange,
   Menge,
   rudern,
   gehen,
   Junge,
   Tontest
};
